<template>
    <div class="inner-container budget-form">
        <div class="section-title budget">
            <i class="icon icon-calculator-coins"></i
            ><span>Бюджетное планирование</span>
        </div>
        <div class="section-subtitle">
            <i class="icon icon-grid"></i>Формирование бюджета
        </div>
        <b-tabs v-model="tabIndex" v-if="listReg" @input="loadTab">
            <b-tab :lazy="!tabs.includes(tabIndex)"
                   :title="trMsg(MSG_BIP + 'grade')"
                   v-if="[1, 2, 3].includes(gradeLevel)"
                   @click="tabRef = 'bipgrade'">
                <template v-show="tabRef === 'bipgrade' && location !== null">
                    <bip-grade ref="bipgrade"
                               :location="location"
                               :levels="levels"
                               :reg-levels="regLevels"
                               :region-budget-list="listReg"
                               :region-list="regionList"
                               :version-list="listVariants"
                               :detail-fields="detailFields"
                               :data-type-list="dataTypeList"
                               :direction-list="directionList"
                               :object-list="objectList"
                               :status-list="statusList"
                               :gp-list="gpList"
                               :exp-types="expTypes"
                               :bip-cif-list="bipCifList"
                               :criteria-values="criteriaValues"
                               :bip-link-criterias="bipLinkCriterias"
                               :bip-link-types="bipLinkTypes"
                               :dict-unit="dictUnit"
                               @submitReport="submitPriority">
                    </bip-grade>
                </template>
            </b-tab>
            <b-tab :lazy="!tabs.includes(tabIndex)"
                   :title="trMsg(MSG_BIP + 'uebp')"
                   v-if="[1, 2, 3].includes(uebpLevel)"
                   @click="tabRef = 'bipuebp'">
                <template v-show="tabRef === 'bipuebp' && location !== null">
                    <bip-uebp ref="bipuebp"
                              :location="location"
                              :mode_level="uebpLevel"
                              :mode_opers="uebpOpers"
                              :levels="levels"
                              :reg-levels="regLevels"
                              :region-budget-list="listReg"
                              :region-list="regionList"
                              :version-list="listVariants"
                              :detail-fields="detailFields"
                              :data-type-list="dataTypeList"
                              :direction-list="directionList"
                              :object-list="objectList"
                              :status-list="statusList"
                              :gp-list="gpList"
                              :exp-types="expTypes"
                              :bip-cif-list="bipCifList"
                              :criteria-values="criteriaValues"
                              :bip-link-criterias="bipLinkCriterias"
                              :bip-link-types="bipLinkTypes"
                              :dict-unit="dictUnit"
                              :gip-list="gipList"
                              @uebpVersion="uebpVersion = $event"
                              @submitReport="repParams = $event"
                              @bipRegion="bipRegionFilters = $event"
                              @repApp="repApp = $event; appNum = $event ? $event.appNum : 68">
                    </bip-uebp>
                </template>
            </b-tab>
            <b-tab v-if="[1, 2, 3].includes(cdfLevel)"
                   :active="cdfLevel>0"
                   :lazy="!tabs.includes(tabIndex)"
                   :title="trMsg(MSG_CDF + 'title')"
                   @click="tabRef = 'costdataform'">
                <template v-if="tabs.includes(tabIndex)">
                    <cost-data-form ref="costdataform"
                                    :mode_level="cdfLevel"
                                    :mode_opers="cdfOpers"
                                    :location="location"
                                    :region-budget-list="listReg"
                                    :versionList="listVariants"
                                    :data-type-list="dataTypeList"
                                    @curFilter="curFilter">
                    </cost-data-form>
                </template>
            </b-tab>
            <b-tab v-if="[1, 2, 3].includes(incLevel)"
                   :lazy="!tabs.includes(tabIndex)"
                   title="Доходы"
                   @click="tabRef = 'inputform'">
                <template v-if="tabs.includes(tabIndex)">
                    <income-form
                        ref="incomeform"
                        :year="parseInt(year)"
                        :obl="location && location.obl"
                        :reg="location && location.region"
                        :list-reg="listReg || []"
                        :list-variants-inc="listVariantsInc || []"
                        :access-level="incLevel"
                    ></income-form>
                </template>
            </b-tab>
            <b-tab v-if="false"
                   :lazy="!tabs.includes(tabIndex)"
                   title="Версия бюджета"
                   @click="tabRef = 'versionform'">
                <budget-variants></budget-variants>
            </b-tab>
            <b-tab
                v-if="isbpConclTabShown"
                lazy
                :title="trMsg(MSG_BP_CONCL + 'bp')"
                @click="tabRef = 'concform'">
                <router-view
                    ref="bpChildView"
                    @setDownloadDisabled="setDownloadDisabled"
                    @setBpInEditMode="setBpInEditMode"
                ></router-view>
            </b-tab>
        </b-tabs>
        <div class="actions-tab in-tab">
            <template v-if="tabIndex === 4">
                <c-budget-program-info
                    :title="trMsg(MSG_BP_CONCL + 'section')"
                    :infoId="43"
                    fileName="РП Заключение по БП"
                    :infoTextLines="bpConclInfoTextLines"
                ></c-budget-program-info>
            </template>
            <b-dropdown v-if="[0, 1, 2, 4].includes(tabIndex)"
                        variant="link"
                        right
                        toggle-class="text-decoration-none"
                        no-caret
                        :disabled="tabIndex === 4 && isDownloadDisabled">
                <template #button-content>
                    <div class="btn-download">
                        <div>
                            <span class="left">
                                <b-spinner v-if="isDownloadDisabled"
                                           variant="success"
                                           small
                                           label="Small Spinner">
                                </b-spinner>
                                <i v-if="tabIndex === 4 && !isDownloadDisabled" class="icon icon-download"></i>
                                {{ trMsg(MSG_BIP + 'btn.download') }}
                            </span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
                <b-dropdown-item v-if="tabIndex === 0" @click="reportPP">
                    {{ trMsg(MSG_BIP + 'report.prj_priority') }}
                </b-dropdown-item>
                <template v-if="tabRef === 'bipuebp'">
                    <b-dropdown-item @click="downloadZProtocol">
                        {{ trMsg(MSG_BIP + 'report.protocol_dis') }}
                    </b-dropdown-item>
                    <b-dropdown-item @click="reportDB">{{ trMsg(MSG_BIP + 'projects') }}</b-dropdown-item>
                    <b-dropdown-item @click="downloadRepApp">{{ trMsg(MSG_BIP + 'app') + ' ' + appNum }}
                    </b-dropdown-item>
                    <b-dropdown-item @click="downloadBipRegionReport">{{ trMsg(MSG_BIP + 'report.dl_bip_region') }}
                    </b-dropdown-item>
                    <b-dropdown-item @click="modalDate">{{ trMsg(MSG_BIP + 'report.dl_bip_region_sum') }}
                    </b-dropdown-item>
                </template>
                <template v-if="tabRef === 'costdataform'">
                    <b-dropdown-item @click="downloadCurExpenses">
                        {{ trMsg(MSG_CDF + 'title') }}
                    </b-dropdown-item>
                    <b-dropdown-item @click="repLimits">
                        {{ trMsg(MSG_CDF + 'report.cur_exp_limit') }}
                    </b-dropdown-item>
                    <b-dropdown-item @click="repBZAbp">
                        {{ trMsg(MSG_CDF + 'report.cur_exp_bzabp') }}
                    </b-dropdown-item>
                    <b-dropdown-item @click="downloadStatuses">
                        {{ trMsg(MSG_CDF + 'report.approval_statuses') }}
                    </b-dropdown-item>
                    <b-dropdown-item @click="downloadDProtocol">
                        {{ trMsg(MSG_BIP + 'report.protocol_dis') }}
                    </b-dropdown-item>
                    <b-dropdown-item :disabled="!curParams.abp"
                                     @click="repPkgConclusion">
                        {{ trMsg(MSG_CDF + 'report.batch_upload_conclusion') }}
                    </b-dropdown-item>
                </template>
                <b-dropdown-item v-if="tabIndex === 4 && bpInEditMode"
                                 @click="onDownloadBudgetProgramReport(2)"
                    >{{ trMsg(MSG_BP_CONCL + 'bp') }}
                </b-dropdown-item>
                <template v-else-if="tabIndex === 4">
                    <b-dropdown-item
                        @click="onDownloadBudgetProgramReport(3)"
                        >{{ trMsg(MSG_BP_CONCL + 'abp') }}
                    </b-dropdown-item>
                    <b-dropdown-item
                        @click="onDownloadBudgetProgramReport(4)"
                        >{{ trMsg(MSG_BP_CONCL + 'abp_no_rb') }}
                    </b-dropdown-item>
                </template>
            </b-dropdown>
            <b-dropdown v-if="[0, 1, 2, 3].includes(tabIndex)"
                        variant="link"
                        class="info"
                        right
                        toggle-class="text-decoration-none"
                        no-caret>
                <template #button-content>
                    <div class="btn-download">
                        <div>
                            <span class="left"><i class="icon icon-info"></i></span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
                <b-dropdown-text>
                    <div class="info-button">
                        <span v-if="tabIndex === 0" @click="infoCostForm(20)">
                            {{ trMsg(MSG_BIP + 'instruction') }}
                            <i class="icon icon-folder"></i></span>
                        <span v-if="tabIndex === 0" @click="infoCostForm(21)">
                            {{ trMsg(MSG_BIP + 'grade_method') }}
                            <i class="icon icon-folder"></i></span>
                        <span v-if="tabIndex === 1" @click="infoCostForm(24)">
                            {{ trMsg(MSG_BIP + 'instruction') }}
                            <i class="icon icon-folder"></i></span>
                        <span v-if="tabIndex === 2" @click="infoCostForm(1)">
                            {{ trMsg(MSG_BIP + 'instruction') }}
                            <i class="icon icon-folder"></i></span>
                        <span v-if="tabIndex === 3" @click="infoCostForm(2)">
                            Режим «Формирование бюджета»
                            <i class="icon icon-folder"></i></span>
                    </div>
                    <!-- <div class="info-button">
                        <span>Видеоинструкция <i class="icon icon-video"></i></span>
                    </div> -->
                    <div class="info-text" v-if="tabIndex === 0">
                        <p><span class="red bold">{{ trMsg(MSG_BIP + 'report.grade') }}</span></p>
                        <p>{{ trMsg(MSG_BIP + 'report.grade_1') }}</p>
                        <p>{{ trMsg(MSG_BIP + 'report.grade_2') }}</p>
                    </div>
                    <div class="info-text" v-if="tabIndex === 1">
                        <p><span class="red bold">{{ trMsg(MSG_BIP + 'report.uebp') }}</span></p>
                        <p>{{ trMsg(MSG_BIP + 'report.uebp_1') }}</p>
                    </div>
                    <div class="info-text" v-if="tabIndex === 2">
                        <p><span class="red bold">{{ trMsg(MSG_CDF + 'sector') }}</span></p>
                        <p>{{ trMsg(MSG_CDF + 'report.cdf_1') }}</p>
                    </div>
                    <div class="info-text" v-if="tabIndex === 3">
                        <p>
                            Данный режим предназначен для ввода, корректировки и
                            просмотра данных по бюджету на очередной плановый
                            период.
                        </p>
                        <p>
                            Режим содержит данные до уровня бюджетных
                            программ/подпрограмм по расходной части и специфик
                            по поступлениям.
                        </p>
                        <p>Режим состоит из следующих разделов:</p>
                        <p>
                            <span class="red bold">Расход</span><br />
                            – формирование расходной части бюджета
                        </p>
                        <p>
                            <span class="red bold">Доход</span><br />
                            – формирование доходной части бюджета
                        </p>
                        <p>
                            <span class="red bold">Баланс</span><br />
                            – отображение данных по структуре бюджета
                        </p>
                    </div>
                </b-dropdown-text>
            </b-dropdown>
        </div>

        <!--Модальные окна-->
        <modal-date ref="refModalDate" @emitDate="downloadBipRegionSummary"></modal-date>
    </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import store from "../../services/store";
import { Ax } from "@/utils";
import i18nService from "@/services/i18n";
import IncomeForm from "@/modules/budget/IncomeForm";
import CostDataForm from "@/modules/budget/CostDataForm";
import BipGrade from "@/modules/budget/bip/bip-grade.vue";
import BipUebp from "@/modules/budget/bip/bip-uebp.vue";
import ModalDate from "@/modules/budget/bip/modal-date.vue";
import BudgetVariants from "@/modules/budget/BudgetVariants";
import CBudgetProgramInfo from "@/modules/budget-request/components/budget-program-info.vue";
import { CUR_YEAR } from "../budget-request/components/js/budgetCurYear";
import { loadVariants } from "@/modules/budget/budgetVariantService";
import {
    getRowKey,
    makeToast,
    sortByField,
    findItem,
    nameLocale,
    itemNameLocale,
    postData,
    initLogging,
    fetchReportBlob,
    trMsg,
    expTypes,
    userUiid,
    MSG_SMS,
    MSG_BIP,
    MSG_FILTER,
    MSG_CDF,
    MSG_FIELD,
    MSG_CARD_SEC,
    DICT_CONFIG,
    pkgDicts,
    getInitialDicts,
    processPkgDicts
} from "./bip/bip-types";

const MSG_BP_CONCL = 'modules.budget_request.budget_programs.concl.';

export default {
    name: "BudgetForm",
    components: {
        BipGrade,
        BipUebp,
        CostDataForm,
        IncomeForm,
        BudgetVariants,
        ModalDate,
        CBudgetProgramInfo,
    },
    $refs: {
        bipgrade: HTMLFormElement,
        bipuebp: HTMLFormElement,
        costdataform: HTMLFormElement
    },
    data() {
        return {
            MSG_BIP: MSG_BIP,
            MSG_FILTER: MSG_FILTER,
            MSG_SMS: MSG_SMS,
            MSG_CDF: MSG_CDF,
            MSG_FIELD: MSG_FIELD,
            MSG_CARD_SEC: MSG_CARD_SEC,
            MSG_BP_CONCL: MSG_BP_CONCL,

            location: null,
            year: null,
            dataType: 1,
            variant: "f1340fa7-e90d-42a2-92ae-a6055dc1d278",
            listReg: [],
            selectedABP: { id: 0, child: [] },
            selectedPRG: { id: 0, child: [] },
            selectedPPR: { id: 0 },
            tabIndex: 0,
            tabs: [],
            tabRef: "",
            listVariants: [],
            listVariantsInc: [],

            isDownloadDisabled: false,
            bpInEditMode: false,

            curParams: {},
            uebpVersion: {},
            repParams: null,
            repPriority: null,
            repApp: null,
            appNum: 68, // datas for app68
            bipRegionFilters: {},

            gradeLevel: 0,
            uebpLevel: 0,
            uebpOpers: [],
            cdfLevel: 0,
            cdfOpers: [],
            incLevel: 0,
            levels: [],
            regLevels: [],
            isbpConclTabShown: false,

            ...getInitialDicts()

            // expTypes: expTypes,
            // regionList: [],
            // dataTypeList: [],
            // directionList: [],
            // objectList: [],
            // statusList: [],
            // gpList: [],
            // gipList: [],
            // bipCifList: [],
            // criteriaValues: new Map(),
            // bipLinkCriterias: [],
            // bipLinkTypes: [],
            // dictUnit: []
        };
    },

    created() {
        this.getLocation();
        this.checkUrl();
    },

    mounted() {
        this.year = CUR_YEAR;

        loadVariants().then((data) => {
            this.listVariantsInc = data;
            this.listVariants = data.map((v) => {
                itemNameLocale(v);
                const str = v.status
                    ? trMsg(this, MSG_FILTER + 'apprvd') + (v.attribute ? ', ' + trMsg(this, MSG_FILTER + 'act') : '')
                    : v.attribute ? trMsg(this, MSG_FILTER + 'act') : '';
                Object.defineProperty(v, 'text', {
                    get: function () {
                        return v['name'] + (str.length > 0 ? " (" + str + ")" : "");
                    }
                });
                return v;
            });
        });
        this.loadUserLevels();
        this.loadBudgetLevel();
        this.procPkgDicts();
        // this.loadBipPackageDicts();
    },

    computed: {
        bpConclInfoTextLines() {
            return [
                trMsg(this, MSG_BP_CONCL + 'info_purpose'),
                trMsg(this, MSG_BP_CONCL + 'info_actions'),
                trMsg(this, MSG_BP_CONCL + 'info_enter'),
                trMsg(this, MSG_BP_CONCL + 'info_approve'),
                trMsg(this, MSG_BP_CONCL + 'info_export')
            ];
        },

        detailFields() {
            return [
                {
                    key: "nomer",
                    label: "№"
                },
                {
                    key: "name",
                    label: trMsg(this, MSG_FIELD + 'project')
                }
            ]
        }
    },

    methods: {
        test() {
            //
        },

        addDetailFields(response) {
            try {
                // Создаем массив элементов одним проходом с помощью map
                const newItems = response.map(item => ({
                    key: item.code,
                    label: item.name,
                    criteria_type: item.criteria_type
                }));

                // Добавляем финальный элемент
                newItems.push({
                    key: "total",
                    label: trMsg(this, MSG_FIELD + 'point')
                });

                // Единоразовое добавление элементов в массив
                this.detailFields.push(...newItems);
            } finally {
                initLogging('budget detailFields', this.detailFields);
            }
        },

        async getLocation() {
            try {
                // Основной запрос данных локации
                const response = await fetch(`/api-py/get-budget-obl/${store.state._instanceCode}`);
                this.location = await response.json();
            } catch (error) {
                // Обработка ошибок единым методом
                this.handleError(error, MSG_SMS + 'error_request', '/get-budget-obl');
                return; // Прерываем выполнение при ошибке
            }

            // Логирование результата
            initLogging('bf location', this.location || 'undefined');

            // Проверка необходимых условий
            if (!this.location || !userUiid) return;

            try {
                // Последовательные зависимые запросы
                await this.loadRegionList();

                // Второй запрос данных
                const regionResponse = await fetch(
                    `/api-py/get-user-regions-by-obl/${this.location.obl}/${userUiid}`
                );
                this.listReg = await regionResponse.json();

                // Обработка данных
                nameLocale(this.listReg);
            } catch (error) {
                makeToast(this, 'danger', trMsg(this, MSG_SMS + 'error_request'),
                    '/get-user-regions-by-obl' + error.toString());
            }
        }, // запрос локации по глобальному коду области

        async curFilter(data) {
            this.curParams = data;
        }, // обновление параметров с раздела Текущих расходов

        infoCostForm(info_id) {
            const that = this;
            Ax(
                {
                    url: "/api-py/get-info/" + info_id, //  Тело файла
                    method: "POST",
                    data: null,
                    responseType: "blob",
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    let file = "";
                    if (info_id === 1) {
                        file = "РП Формирование расходной части";
                    }
                    if (info_id === 2) {
                        file = "РП Формирование доходной части";
                    }
                    if (info_id === 20) {
                        file = trMsg(this, MSG_BIP + 'report.instr_grade');
                    }
                    if (info_id === 21) {
                        file = trMsg(this, MSG_BIP + 'grade_method');
                    }
                    if (info_id === 24) {
                        file = trMsg(this, MSG_BIP + 'report.instr_uebp');
                    }
                    link.setAttribute("download", file + ".pdf"); // or any other extension
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    console.error(error)
                },
            );
        },

        // формирование отчета
        downloadAgrExcel() {
            const that = this;
            Ax(
                {
                    url:
                        "/api-py/agr-form-download/" +
                        that.location.region +
                        "/" +
                        that.variant +
                        "/" +
                        that.year +
                        "/" +
                        that.selectedABP.id +
                        "/" +
                        that.selectedPRG.id, //  Тело файла
                    method: "POST",
                    data: that.ajxParams,
                    responseType: "blob",
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute(
                        "download",
                        "Бюджет в агрегированной форме.xls",
                    ); // or any other extension
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    that.error = error;
                },
            );
        },
        // формирование отчета
        downloadExcel() {
            const that = this;
            Ax(
                {
                    url:
                        "/api-py/summary-form-download/" +
                        that.location.region +
                        "/" +
                        that.variant +
                        "/" +
                        that.year +
                        "/" +
                        that.selectedABP.id +
                        "/" +
                        that.selectedPRG.id, //  Тело файла
                    method: "POST",
                    data: that.ajxParams,
                    responseType: "blob",
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute(
                        "download",
                        "Бюджет на предстоящий период.xls",
                    ); // or any other extension
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    that.error = error;
                },
            );
        },
        // формирование отчета
        downloadVedmExcel() {
            const that = this;
            Ax(
                {
                    url:
                        "/api-py/ved-form-download/" +
                        that.location.region +
                        "/" +
                        that.variant +
                        "/" +
                        that.year +
                        "/" +
                        that.selectedABP.id +
                        "/" +
                        that.selectedPRG.id, //  Тело файла
                    method: "POST",
                    data: that.ajxParams,
                    responseType: "blob",
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute(
                        "download",
                        "Бюджет по ведомственной классиф.xls",
                    ); // or any other extension
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    that.error = error;
                },
            );
        },

        // формирование протокола расхождения (текущие расходы)
        async downloadDProtocol() {
            const params = {
                lang: `${i18nService.locale}`,
                year: this.curParams.version.year,
                dataType: this.curParams.version.data_type,
                region: this.curParams.version.region_code,
                variant: this.curParams.version.variant_uuid
            };
            Ax(
                {
                    url: "/api-py/dp_count/" + JSON.stringify(params),
                    method: "GET"
                },
                (data) => {
                    if (data > 0) {
                        Ax(
                            {
                                url: "/api-py/dprotocol-download/" + JSON.stringify(params), //  Тело файла
                                method: "POST",
                                responseType: "blob"
                            },
                            (data) => {
                                const url = window.URL.createObjectURL(new Blob([data]));
                                const link = document.createElement("a");
                                link.href = url;
                                link.setAttribute("download",
                                    trMsg(this, MSG_CDF + 'report.protocol_dis') +
                                    ' (' + trMsg(this, MSG_CDF + 'title') + ').xls'); // or any other extension
                                document.body.appendChild(link);
                                link.click();
                            },
                            (error) => {
                                makeToast(this, 'danger', trMsg(this, MSG_SMS + 'attention'), error.toString());
                            }
                        );
                    } else {
                        makeToast(this, "warning", trMsg(this, MSG_SMS + 'attention'),
                            trMsg(this, MSG_CDF + 'no_dis_between_ABP_UEBP'));
                    }
                },
                (error) => {
                    makeToast(this, 'danger', trMsg(this, MSG_SMS + 'attention'), error.toString());
                }
            );
        },

        // формирование протокола расхождения (расходы развития)
        downloadZProtocol() {
            this.$refs.bipuebp.emitUebpVersion();

            if (!this.uebpVersion) {
                makeToast(this, "warning", trMsg(this, MSG_SMS + 'attention'),
                    "Данные версии не получены. Пожалуйста, выберите версию.");
                return;
            }

            const uebpDatas = {
                lang: `${i18nService.locale}`,
                year: this.uebpVersion.year,
                region: this.uebpVersion.region_code,
                dataType: this.uebpVersion.data_type,
                variant: this.uebpVersion.variant_uuid,
                };
            Ax(
                {
                    url: "/api-py/zp_count/" + JSON.stringify(uebpDatas),
                    method: "GET"
                },
                (data) => {
                    if (data > 0) {
                        this.$refs.bipuebp.pBar = 10;
                        Ax(
                            {
                                url: "/api-py/zprotocol-download/" + JSON.stringify(uebpDatas), //  Тело файла
                                method: "POST",
                                responseType: "blob"
                            },
                            (data) => {
                                this.$refs.bipuebp.pBar = 100;
                                const url = window.URL.createObjectURL(new Blob([data]));
                                const link = document.createElement("a");
                                link.href = url;
                                link.setAttribute("download",
                                    trMsg(this, MSG_BIP + 'report.protocol_dis')
                                    + '(' + trMsg(this, MSG_BIP + 'uebp') + ')' + '.xls'); // or any other extension
                                document.body.appendChild(link);
                                link.click();
                            },
                            (error) => {
                                makeToast(this, "danger", trMsg(this, MSG_SMS + 'attention'),
                                    error.toString());
                            }
                        );
                    } else {
                        makeToast(this, "warning", trMsg(this, MSG_SMS + 'attention'),
                            trMsg(this, MSG_CDF + 'no_dis_between_ABP_UEBP'));
                    }
                }, (error) => {
                    makeToast(this, "danger", trMsg(this, MSG_SMS + 'attention'),
                        error.toString());
                },
            );
        },

        // формирование отчета (Текущие расходы)
        async downloadCurExpenses() {
            const params = {
                lang: `${i18nService.locale}`,
                year: this.curParams.version.year,
                dataType: this.curParams.version.data_type,
                region: this.curParams.version.region_code,
                variant: this.curParams.version.variant_uuid,
                abp: (this.curParams.abp ? this.curParams.abp : 0)
            };

            this.$refs.costdataform.pBar = 10;
            Ax(
                {
                    url: "/api-py/rep-currexp/" + JSON.stringify(params), //  Тело файла
                    method: "POST",
                    responseType: "blob"
                }, (data) => {
                    this.$refs.costdataform.pBar = 100;
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download",
                        trMsg(this, MSG_CDF + 'title') +
                        '_' + params.year + '-' + (params.year + 2) + '.xls'); // or any other extension
                    document.body.appendChild(link);
                    link.click();
                }, (error) => {
                    makeToast(this, 'danger', trMsg(this, MSG_SMS + 'attention'), error.toString());
                }
            );
        },

        // формирование отчета (Текущие расходы с учетом Лимита)
        async repLimits() {
            const params = {
                lang: `${i18nService.locale}`,
                // year: this.curParams.version.year,
                // data_type: this.curParams.version.data_type,
                // region: this.curParams.version.region_code,
                variant: this.curParams.version.variant_uuid,
                // prev_variant: this.curParams.version.prev_variant,
                abp: (this.curParams.abp ? this.curParams.abp : 0)
            };

            this.$refs.costdataform.pBar = 10;
            Ax(
                {
                    url: "/api-py/cur-exp-limit/" + JSON.stringify(params), //  Тело файла
                    method: "POST",
                    responseType: "blob"
                }, (data) => {
                    this.$refs.costdataform.pBar = 100;
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download",
                        trMsg(this, MSG_CDF + 'report.cur_exp_limit') +
                        '_' + this.curParams.version.year + '-' + (this.curParams.version.year + 2) + '.xls'); // or any other extension
                    document.body.appendChild(link);
                    link.click();
                }, (error) => {
                    makeToast(this, 'danger', trMsg(this, MSG_SMS + 'attention'), error.toString());
                }
            );
        },

        // формирование отчета (Текущие расходы с учетом БЗ АБП)
        async repBZAbp() {
            const params = {
                lang: `${i18nService.locale}`,
                variant: this.curParams.version.variant_uuid,
                abp: (this.curParams.abp ? this.curParams.abp : 0)
            };

            this.$refs.costdataform.pBar = 10;
            Ax(
                {
                    url: "/api-py/cur-exp-bzabp/" + JSON.stringify(params), //  Тело файла
                    method: "POST",
                    responseType: "blob"
                }, (data) => {
                    this.$refs.costdataform.pBar = 100;
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download",
                        trMsg(this, MSG_CDF + 'report.cur_exp_bzabp') +
                        '_' + this.curParams.version.year + '-' + (this.curParams.version.year + 2) + '.xls'); // or any other extension
                    document.body.appendChild(link);
                    link.click();
                }, (error) => {
                    makeToast(this, 'danger', trMsg(this, MSG_SMS + 'attention'), error.toString());
                }
            );
        },

        // формирование отчета (статусы согласования)
        async downloadStatuses() {
            const params = {
                lang: `${i18nService.locale}`,
                year: this.curParams.version.year,
                data_type: this.curParams.version.data_type,
                region: this.curParams.version.region_code,
                variant: this.curParams.version.variant_uuid,
                abp: (this.curParams.abp ? this.curParams.abp : 0)
            };

            Ax(
                {
                    url: "/api-py/report-status/" + JSON.stringify(params), //  Тело файла
                    method: "POST",
                    responseType: "blob"
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download",
                        trMsg(this, MSG_CDF + 'report.approval_statuses') +
                        '_' + params.year + "-" + (params.year + 2) + '.xls');
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    makeToast(this, 'danger', trMsg(this, MSG_SMS + 'attention'), error.toString());
                }
            );
        },

        loadTab() {
            if (this.tabs.length > 0) {
                this.setUrl(this.tabIndex);
            }
            if (!this.tabs.includes(this.tabIndex)) {
                this.tabs.push(this.tabIndex);
            }
        }, // загрузка при открытии вкладки

        async loadUserLevels() {
            if (!userUiid) return;
            try {
                const response = await fetch("/api-py/user-modules/" + userUiid)
                    .then((response) => response.json());
                for (const row of response) {
                    switch (row.modules) {
                        case "004.003.001":
                            this.gradeLevel = row.access_level;
                            break;
                        case "004.003.002":
                            this.uebpLevel = row.access_level;
                            this.uebpOpers = row.operations;
                            break;
                        case "004.003.003":
                            this.cdfLevel = row.access_level;
                            this.cdfOpers = row.operations;
                            break;
                        case "004.003.004":
                            this.incLevel = row.access_level;
                            break;
                        case "004.003.006":
                            this.isbpConclTabShown = true;
                            break;
                        default:
                            break;
                    }
                }
            } catch (error) {
                makeToast(this, "danger", trMsg(this, MSG_SMS + 'attention'),
                    trMsg(this, MSG_SMS + 'error_request') + ' /api-py/user-modules/');
            } finally {
                initLogging('gradeLevel', this.gradeLevel);
                initLogging('uebpLevel', this.uebpLevel);
                initLogging('cdfLevel', this.cdfLevel);

                if (this.cdfLevel > 0) {
                    this.tabRef = 'costdataform';
                    this.tabIndex = 2;
                }
            }
        },

        // Пакетная выгрузка (Заключение)
        repPkgConclusion() {
            const params = {
                lg: `${i18nService.locale}`,
                year: this.curParams.version.year,
                dataType: this.curParams.version.data_type,
                region: this.curParams.version.region_code,
                variant: this.curParams.version.variant_uuid,
                abp: (this.curParams.abp ? this.curParams.abp : 0),
                datas: this.curParams.datas,
                pprMap: this.curParams.pprMap
            };

            // п. 9.3: пакетная выгрузка недоступна без выбранного АБП
            if (!params.abp || params.abp === 0) {
                makeToast(this, 'warning', trMsg(this, MSG_SMS + 'attention'),
                    trMsg(this, MSG_CDF + 'sel_ABP'));
                return;
            }
            const urls_list = []

            if (params.datas) {
                for (const prg of params.datas.child) {

                    if (prg.value['pprChild']) {
                        for (const ppr of prg.value.child) {

                            if (ppr.value.child.length > 0) {
                                this.newUrl(params, ppr.value.abp, ppr.value.prg, ppr.value.ppr,
                                    prg.value['abp'] + '.' + prg.value['prg'] + ' ' + prg.value['name_' + params.lg],
                                    ppr.value['ppr'] + ' ' + ppr.value['name_' + params.lg],
                                    ppr.value.child, urls_list);
                            }
                        }
                    } else {
                        if (prg.value.child.length > 0) {
                            this.newUrl(params, prg.value.abp, prg.value.prg, null,
                                prg.value['abp'] + '.' + prg.value['prg'] + ' ' + prg.value['name_' + params.lg],
                                null, prg.value.child, urls_list);
                        }
                    }
                }

                if (urls_list.length > 0) {
                    Ax({
                            url: "/api-py/download-post-archive/",
                            method: "POST",
                            data: {
                                archive_name: "archive.zip",
                                urls_list: urls_list
                            },
                            responseType: "blob"
                        },
                        (data) => {
                            if (data) {
                                const url = window.URL.createObjectURL(new Blob([data]));
                                const link = document.createElement('a');
                                link.href = url;
                                link.setAttribute('download',
                                    'БЗ_Прогноз_' + params.abp + '_' + params.year + '-' + (params.year+2) + '.zip');// or any other extension
                                document.body.appendChild(link);
                                link.click();
                            }
                        },
                        (error) => {
                            makeToast(this, "danger", trMsg(this, MSG_SMS + 'attention'),
                                trMsg(this, MSG_SMS + 'error_request') + ' /download-post-archive ' + error.toString());
                        }
                    );
                } else {
                    makeToast(this, 'warning', trMsg(this, MSG_SMS + 'attention'), trMsg(this, MSG_SMS + 'ABP_datas_absence'))
                }
            }
        },

        newUrl(params, abp, prg, ppr, prg_name, ppr_name, list, urls_list) {
            const report = {
                lg: params.lg,
                year: params.year,
                region: params.region,
                variant: params.variant,
                abp: params.abp
            }

            const datas = []
            for (const row of list) {
                const ppr = params.pprMap.get(getRowKey(row.value, ["abp", "prg", "ppr", "spf"]))

                if (ppr && ppr.request1 + ppr.request2 + ppr.request3
                    + ppr.plan1 + ppr.plan2 + ppr.plan3 > 0
                    && ppr.forms !== null) {
                    datas.push(ppr);
                }
            }

            if (datas.length > 0) {
                this.$set(report, 'prg', prg_name);
                this.$set(report, 'ppr', ppr_name);
                this.$set(report, 'datas', datas);

                const item = {
                    filename: trMsg(this, MSG_BIP + 'report.conclusion.title') + '_'
                        + abp + '_' + prg + (ppr === null ? '' : '_' + ppr) + '.xls',
                    url: window.location.origin  + '/api-py/pkg-conclusion/',
                    body: report
                }
                urls_list.push(item);
            }
        },

        downloadBipRegionReport() {
            // Запрашиваем актуальные данные у дочернего компонента
            this.$refs.bipuebp.emitBipRegion();
            const now = new Date();
            const dateTimeStr =
                now.getFullYear() + '-' +
                String(now.getMonth() + 1).padStart(2, '0') + '-' +
                String(now.getDate()).padStart(2, '0') + ' ' +
                String(now.getHours()).padStart(2, '0') + '-' +
                String(now.getMinutes()).padStart(2, '0');

            // Проверяем, что все необходимые параметры есть
            if (!this.uebpVersion || !this.bipRegionFilters) {
                makeToast(this, "warning", "Не удалось получить параметры отчёта");
                return;
            }

            // Формируем объект параметров для API
            const params = Object.assign({},
                this.uebpVersion, this.bipRegionFilters,
                { lang: i18nService.locale });

            // Вызов API и скачивание...
            Ax(
                {
                    url: "/api-py/report-bip-region/", //  Тело файла
                    method: "POST",
                    data: params,
                    responseType: "blob"
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download",
                        trMsg(this, MSG_BIP + 'report.xls_bip_region') + ' '
                        + params.year + "-" + (params.year + 2) + ' '
                        + params.region['name_' + params.lang]+ ' '
                        + dateTimeStr + '.xls');
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    makeToast(this, 'danger', trMsg(this, MSG_SMS + 'attention'), error.toString());
                }
            );
        },

        modalDate() {
            this.$refs.refModalDate.showEvent();
        },

        downloadBipRegionSummary(data) {

            // Запрашиваем актуальные данные у дочернего компонента
            this.$refs.bipuebp.emitUebpVersion();
            this.$refs.bipuebp.emitBipRegion();

            const dateTimeStr =
                data.getFullYear() + '-' +
                String(data.getMonth() + 1).padStart(2, '0') + '-' +
                String(data.getDate()).padStart(2, '0');

            // Проверяем, что все необходимые параметры есть
            if (!this.uebpVersion || !this.bipRegionFilters) {
                makeToast(this, "warning", trMsg(this, MSG_SMS + 'attention'),
                    "Не удалось получить параметры отчёта");
                return;
            }

            // Формируем объект параметров для API
            const params = Object.assign({},
                this.uebpVersion, this.bipRegionFilters,
                { budget_date: dateTimeStr },
                { lang: i18nService.locale });

            // Сначала лёгкой проверкой убеждаемся, что отчёту есть что выгружать,
            // и только тогда сообщаем о начале скачивания — до формирования файла
            fetch("/api-py/report-bip-region-summary/check/", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(params)
            })
                .then(response => response.json())
                .then(check => {
                    if (!check.success) {
                        throw new Error(check.error || 'Произошла ошибка');
                    }

                    makeToast(this, 'primary', trMsg(this, MSG_SMS + 'attention'),
                        'Скоро начнется скачивание. Пожалуйста, ожидайте.');

                    return fetch("/api-py/report-bip-region-summary/", {
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(params)
                    });
                })
                .then(async response => {
                    // Проверяем Content-Type
                    const contentType = response.headers.get('content-type');

                    if (contentType && contentType.includes('application/json')) {
                        // Это JSON ответ (возможно ошибка)
                        const json = await response.json();
                        console.log('JSON response:', json);

                        if (json.success === false) {
                            // Это ошибка
                            throw new Error(json.error || 'Произошла ошибка');
                        }
                        // Если success !== false, но это JSON - значит что-то пошло не так
                        throw new Error('Неожиданный формат ответа');
                    }

                    // Это файл (blob)
                    const blob = await response.blob();
                    return blob;
                })
                .then(blob => {
                    // Скачиваем файл
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download",
                        trMsg(this, MSG_BIP + 'report.dl_bip_region_sum') + ' ' +
                        params.year + "-" + (params.year + 2) + ' ' +
                        params.region['name_' + params.lang] + ' ' +
                        dateTimeStr + '.xls');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                })
                .catch(error => {
                    console.log('Error caught:', error);
                    const errorMessage = error.message || 'Произошла ошибка при скачивании отчёта';
                    makeToast(this, 'warning', trMsg(this, MSG_SMS + 'attention'), errorMessage);
                });
        },

        downloadRepApp() {
            this.$refs.bipuebp.emitAppDatas(this.appNum);

            if (!this.repApp || !this.repApp.abp || !this.repApp.prg) {
                makeToast(this, 'primary', trMsg(this, MSG_SMS + 'warning'),
                    trMsg(this, MSG_SMS + 'sel_ABP_BP'));
                return;
            }

            if (this.repApp.sign_code?.length === 1
                && this.repApp.sign_code[0].id_user?.length === 0) {
                makeToast(this, "warning", trMsg(this, MSG_SMS + 'attention'),
                    trMsg(this, MSG_SMS + 'absent_signatories'));
            }

            const { abp, prg, ppr, variant_uuid, year, data_type, appNum, lang } = this.repApp;

            fetchReportBlob(this, appNum, year, data_type, variant_uuid, abp, prg, ppr);
        },

        reportDB() {
            this.$refs.bipuebp.submitReport();
            Ax(
                {
                    url: "/api-py/bip-application-db/",
                    method: "POST",
                    data: this.repParams,
                    responseType: "blob"
                },
                (data) => {
                    if (data) {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("download",
                            trMsg(this, MSG_BIP + 'uebp') + '_' + this.repParams.planPeriod.name + ".xls");
                        document.body.appendChild(link);
                        link.click();
                    }
                },
                () => {
                    makeToast(this, "danger", trMsg(this, MSG_SMS + 'attention'),
                        trMsg(this, MSG_SMS + 'error_request') + ' /bip-application-db');
                }
            );
        },

        reportPP() {
            this.$refs.bipgrade.submitReport();
            Ax(
                {
                    url: "/api-py/bip-application-pp/",
                    method: "POST",
                    data: this.repPriority,
                    responseType: "blob"
                },
                (data) => {
                    if (data) {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("download",
                            trMsg(this, MSG_BIP + 'report.prj_priority') + '_' + this.repPriority.year + ".xls");
                        document.body.appendChild(link);
                        link.click();
                    }
                },
                () => {
                    makeToast(this, "danger", trMsg(this, MSG_SMS + 'attention'),
                        trMsg(this, MSG_SMS + 'error_request') + ' /api-py/bip-application-pp/');
                }
            );
        },

        submitPriority(data) {
            this.repPriority = data;
        },

        setDownloadDisabled(val) {
            this.isDownloadDisabled = val;
        },

        setBpInEditMode(val) {
            this.bpInEditMode = val;
        },

        async loadBipPackageDicts() {
            const DICT_KEYS = Object.keys(DICT_CONFIG);

           // 1. Инициализация всех свойств через default
            Object.values(DICT_CONFIG).forEach(config => {
                this[config.dict] = config.default ? config.default() : [];
            });
            this.expTypes = [];

            try {
                const response = await postData('/api-py/bip-package-dicts', DICT_KEYS);

                // 2. Обработка данных из API с сортировкой
                Object.entries(DICT_CONFIG).forEach(([responseKey, config]) => {
                    const data = response[responseKey];

                    if (!Array.isArray(data)) {
                        return;
                    }

                    let processedData = [...data];

                    // Применяем сортировку если указана в конфиге
                    if (config.field && config.fn) {
                        processedData = processedData.sort(config.fn(config.field));
                    }

                    this[config.dict] = processedData;
                    nameLocale(processedData);
                });

                // 3. Обработка expTypes
                this.expTypes = expTypes || [];
                nameLocale(this.expTypes);

                // 4. Специальная обработка directionList (object_types внутри элементов)
                if (this.directionList) {
                    this.directionList.forEach(item => {
                        if (item.object_types && Array.isArray(item.object_types)) {
                            nameLocale(item.object_types);
                        }
                    });
                }

                // 5. Дополнительная обработка для bipCifList
                if (this.bipCifList) {
                    this.addDetailFields(this.bipCifList);
                }

                // 6. Обработка критериев
                if (response.bip_criteria_values) {
                    this.criteriaValues = new Map(
                        response.bip_criteria_values.map((row) => [
                            getRowKey(row, ['criteria', 'link', 'year']),
                            row
                        ])
                    );
                    // Локализуем исходный массив (уже сделано в основном цикле через this.criteriaValues)
                }

                // 7. Оптимизированная обработка bipLinkCriterias
                if (this.bipLinkCriterias && this.bipCifList && this.bipLinkTypes) {
                    this.bipLinkCriterias.forEach(blc => {
                        try {
                            // Поиск связанного CIF
                            const [cif] = this.bipCifList.filter(row => row.code === blc.criteria);
                            if (cif) {
                                Object.entries(cif)
                                    .filter(([key]) => !['id', 'begin_date', 'end_date'].includes(key))
                                    .forEach(([key, value]) => this.$set(blc, key, value));

                                this.$set(blc, 'unit_item',
                                    findItem(blc.unit, 'national_symbol', this.dictUnit));
                            }

                            // Поиск связанного типа связи
                            const [blt] = this.bipLinkTypes.filter(row => row.id === blc.link);
                            if (blt) {
                                Object.entries(blt)
                                    .filter(([key]) => key !== 'id')
                                    .forEach(([key, value]) => this.$set(blc, key, value));

                                const setYear = (dateKey, yearKey) =>
                                    this.$set(blc, yearKey,
                                        blt[dateKey] ? new Date(blt[dateKey]).getFullYear() : null);

                                setYear('begin_date', 'begin_year');
                                setYear('end_date', 'end_year');
                            }
                        } catch (error) {
                            console.error(`Criteria error [${blc.id}]:`, error);
                        }
                    });
                }

            } catch (error) {
                makeToast(this, 'danger',
                    trMsg(this, MSG_SMS + 'error_request'),
                    '/bip-package-dicts ' + error.toString());
            }
        },

        async procPkgDicts() {
            const DICT_KEYS = Object.keys(DICT_CONFIG);

            try {
                const response = await pkgDicts(this, DICT_KEYS);

                await processPkgDicts(this, response);
            } catch (error) {
                makeToast(this, 'danger',
                    trMsg(this, MSG_SMS + 'error_request'),
                    'procPkgDicts ' + error.toString());
            }
        },

        async loadBudgetLevel() {
            try {
                const result = await fetch(
                    encodeURI("/api-py/get-user-budget-level/" + userUiid),
                ).then((response) => response.json());

                const budgetLevel = result
                    .map(el => {
                        const indx = el.budget_level.lastIndexOf('_');
                        return indx >= 0 ? parseInt(el.budget_level.slice(indx + 1)) : null;
                    }).filter((level) => level !== null);

                const levelMap = {
                    2: { levels: [2], regLevels: [3] },
                    3: { levels: [2, 3], regLevels: [3, 4] },
                    4: { levels: [4, 3], regLevels: [4] }
                };

                const { levels, regLevels } = budgetLevel.reduce((acc, level) => {
                        const config = levelMap[level];
                        if (config) {
                            acc.levels.push(...config.levels.filter(l => !acc.levels.includes(l)));
                            acc.regLevels.push(...config.regLevels.filter(l => !acc.regLevels.includes(l)));
                        }
                        return acc;
                    },
                    { levels: [], regLevels: [] });

                this.levels = [...new Set(levels)];
                this.regLevels = [...new Set(regLevels)];

                if (budgetLevel.length === 0) {
                    makeToast(this, 'warning',
                        trMsg(this, MSG_SMS + 'attention'),
                        trMsg(this, MSG_SMS + 'no_available_user_budget_levels'));
                }

            } catch (error) {
                makeToast(this, 'danger',
                    trMsg(this, MSG_SMS + 'error_request'),
                    '/get-user-budget-level' + error.toString());
            } finally {
                initLogging('form budgetLevel', {levels: this.levels, regLevels: this.regLevels});
            }
        },

        async loadRegionList() {
            if (!this.location?.code) return;

            try {
                const regions = await fetch("/api-py/get-kato-regions/" + this.location.code)
                    .then((response) => response.json());

                const processedRegions = await Promise.all(
                    regions.map(async region => {
                        if (region.code.substring(2, 3) === '0'
                            && parseInt(region.code.substring(0, 2), 10) < 71) return null;

                        try {
                            const localities = await fetch("/api-py/get-kato-localities/" + region["code"].substring(0, 4))
                                .then((response) => response.json());
                            nameLocale(localities);
                            localities.sort(sortByField("name"));
                            return { ...region, localityList: [{ name: '' }, ...localities] };
                        } catch (error) {
                            makeToast(this, 'danger', trMsg(this, MSG_SMS + 'attention'),
                                trMsg(this, MSG_SMS + 'error_request') + ' /get-kato-localities');
                            return { ...region, localityList: [] };
                        }
                    })
                );

                this.regionList = processedRegions
                    .filter((region) => !!region)
                    .sort((a, b) => a.code.localeCompare(b.code));

                nameLocale(this.regionList);
            } catch (error) {
                makeToast(this, 'danger', trMsg(this, MSG_SMS + 'error_request'),
                    '/get-kato-regions ' + error.toString());
            } finally {
                initLogging('bf regionList', this.regionList);
            }
        }, // загрузка районов по области

        checkUrl() {
            if (this.$route.name === 'budget-form-concl-bp') {
                this.tabIndex = 4;
            }
        },

        setUrl(tabIndex) {
            switch (tabIndex) {
                case 4:
                    if (this.$route.name === 'budget-form-concl-bp') break;
                    this.$router.push({
                        name: 'budget-form-concl-bp',
                    });
                    break;
                default:
                    if (this.$route.name === 'budget-form') break;
                    this.$router.push({
                        name: 'budget-form',
                    });
            }
        },

        onDownloadBudgetProgramReport(repId) {
            this.$refs.bpChildView.bpReportGeneration(repId, true);
        },

        // translate messages
        trMsg(field) {
            return trMsg(this, field);
        }
    }
};
</script>

<style>
.is-hidden {
    display: none !important;
}
</style>
